import { useEffect, useState } from "react";
import { FaWhatsapp } from "react-icons/fa";
import { doc, collection, getDoc } from "firebase/firestore";
import { firestore } from "../firebase-config";
import { id_firebase } from "../content-site";
import { retiraMascara } from "../utils/retiraMascara";

export default function WhatsappFloatButton() {
    const [telefone, setTelefone] = useState("");

    useEffect(() => {
        const revendaRef = doc(collection(firestore, "revenda"), id_firebase);
        getDoc(revendaRef).then((docSnap) => {
            if (docSnap.exists()) {
                setTelefone(retiraMascara(docSnap.data().petelefone2, "link"));
            }
        });
    }, []);

    if (!telefone) return null;

    return (
        <a
            href={`https://api.whatsapp.com/send?phone=55${telefone}`}
            target="_blank"
            rel="noopener noreferrer"
            className="fixed z-50 bottom-6 right-6 bg-green-600 hover:bg-green-700 text-white rounded-full shadow-lg p-4 flex items-center justify-center transition-all"
            aria-label="Fale conosco no WhatsApp"
            style={{ boxShadow: "0 4px 16px rgba(0,0,0,0.2)" }}
        >
            <FaWhatsapp className="text-3xl" />
        </a>
    );
}